import { Directive, Input, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
// import { Gtag } from 'angular-gtag';
import { ActivatedRoute, Router } from '@angular/router';

@Directive({
  selector: '[cpGTagEvent]',
  standalone: false
})

// task 11044
export class CPGTagEventDirective implements AfterViewInit {
  @Input() trackOn: string = 'click';
  @Input() action: string = 'clicked';
  @Input() category: string;
  @Input() params: any;

  constructor(
    // private gtag: Gtag,
    private renderer: Renderer2,
    private el: ElementRef,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit() {
    // try {
    //   this.renderer.listen(this.el.nativeElement, this.trackOn, () => {
    //     const params = { ...this.params };
    //     // data passed via form submit button
    //     if (params.data) {
    //       params.data = JSON.stringify(params.data);
    //     }
    //     // if no page title exists in params, override if one exists on route def
    //     // note that this is not pulled from angular's title service, since that
    //     // will have the client code prepended to the page title (if on a client page)
    //     if (!params.page_title) {
    //       let child = this.route.root.firstChild;
    //       while (child.firstChild) {
    //         child = child.firstChild;
    //       }
    //       params.page_title = child.snapshot.data['title'];
    //     }
    //     this.gtag.event(this.action || this.trackOn, {
    //       event_category: this.category,
    //       ...params
    //     });
    //   });
    // } catch (err) {
    //   console.error(err);
    // }
  }
}
